import CryptoJS from 'crypto-js';
import axios from 'axios';
import { btoa, atob } from '../../lib/helpers';
import { postApi } from '../../lib/fetcher';

const mappingMID = {
  namespaced: true,

  state() {
    return {
      allMerchants: [],
      totalMerchants: 0,
      totalPage: 0,
      loading: false,
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      detail: null,
      allUser: [],
      loadingUser: false,
      requestUser: null,
    };
  },

  mutations: {
    setMerchants(state, { payload }) {
      state.allMerchants = payload.data.list;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearMerchants(state) {
      state.allMerchants = [];
      state.totalMerchants = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalMerchants(state, { payload }) {
      state.totalMerchants = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    clearErrorVariable(state, variable) {
      state.errors[variable] = [];
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setDetailData(state, payload) {
      state.detail = payload;
    },

    setUsers(state, { payload }) {
      state.allUser = payload.data.list;
    },

    setLoadingUser(state, loading) {
      state.loadingUser = loading;
    },

    setCancelationUser(state, payload) {
      state.requestUser = payload;
    },
  },

  actions: {
    async fetchListMapping(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search }
    ) {
      ctx.commit('clearMerchants');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/maaping_mid/mid/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setTotalMerchants', {
          payload: responseData,
        });
        ctx.commit('setMerchants', { payload: responseData });
      }
    },

    async fetchMerchants(
      ctx,
      {
        date,
        page,
        itemsPerPage,
        sortBy,
        sortDesc,
        search,
        assignedOnly,
        user_id,
      }
    ) {
      ctx.commit('clearMerchants');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        assigned_only: assignedOnly,
        user_id,
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/maaping_mid/mid/accounts`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setTotalMerchants', {
          payload: responseData,
        });
        ctx.commit('setMerchants', { payload: responseData });
      }
    },

    async getUserByRoleType(ctx, { date, role_type, search }) {
      if (ctx.state.requestUser) ctx.state.requestUser.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelationUser', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('setLoadingUser', true);
      const data = JSON.stringify({
        search,
        role_type,
        version: btoa(
          CryptoJS.SHA256(
            role_type.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/maaping_mid/mid/role-type`;
      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setUsers', { payload: responseData });
      }
    },

    async save(ctx, { date, id, user_id, edit }) {
      ctx.commit('setLoading', true);

      const data = JSON.stringify({
        account_id: id,
        user_id,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const urlApi = `/index.php?r=api/v1/maaping_mid/mid/${
        edit ? 'update-mid' : 'save-mid'
      }`;

      const responseData = await postApi(ctx, urlApi, data);

      const failed = () => {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Mapping MID Failed !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
      };
      let resVal = false;
      if (responseData?.code == 200) {
        resVal = responseData;
      } else {
        failed();
      }
      return resVal;
    },

    async viewMappingDetail(ctx, { date, user_id, account_id }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        user_id,
        account_id,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/maaping_mid/mid/view`;

      const responseData = await postApi(ctx, urlApi, data);

      let resVal = false;
      if (responseData?.code == 200) {
        resVal = responseData;
      }
      return resVal;
    },
  },
};
export default mappingMID;
